export enum ChannelBackingStorage {
  Firestore = "firestore",
  Stream = "stream",
}

export const channelBackingStorageValues = Object.values(ChannelBackingStorage);
